import React from "react";
import styles from "../Block.module.css";

const TextBlock = ({ title = "", value = "" }) => (
	<div className={styles.innerContainer}>
		<div className={styles.title}>{title}</div>
		<div>{value || "-"}</div>
	</div>
);

export default TextBlock;
